"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { WorkspaceElementType } from '@membranehq/sdk';
import { useElement } from '../element/useElement.mjs';

function useConnection(id) {
  const { item: connection, ...rest } = useElement(WorkspaceElementType.Connection, id, (integrationApp) => id ? integrationApp.connection(id) : void 0);
  return {
    connection,
    ...rest
  };
}

export { useConnection };
